export default __webpack_public_path__ + "static/media/anfora.74a80e0d.svg";